module.exports = __webpack_public_path__ + "static/media/scanner_icon.829d069b.png";